'use client';

import React from 'react';
import { useDrawer } from 'src/hooks/drawers/useDrawer';
import useTableFilterSelections from 'src/hooks/filters/useTableFilterSelections';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';

interface RoundAddButtonProps {
  location: string;
  onTransitionStart?: () => void;
  onRefresh?: () => void; // Add new prop for immediate refresh
}

const RoundAddButton: React.FC<RoundAddButtonProps> = ({
  location,
  onTransitionStart,
  onRefresh,
}) => {
  const { closeAllButCurrent } = useDrawer();
  const { setColumnId } = useTableFilterSelections(location);

  return (
    <div className="flex items-center justify-center w-full">
      <button
        className="w-8 h-8 bg-teal-600 rounded-full 
          flex items-center justify-center hover:bg-teal-500"
        onClick={(e) => {
          e.stopPropagation();

          // Call onTransitionStart if provided
          if (onTransitionStart) {
            onTransitionStart();
          }

          closeAllButCurrent(`table-volume-${location}`);

          // Set column ID immediately without delay
          setColumnId(null);

          // Call onRefresh immediately to force update
          if (onRefresh) {
            onRefresh();
          }
        }}
      >
        <Icon icon={faPlus} className="w-3 h-3 text-white" />
      </button>
    </div>
  );
};

export default RoundAddButton;
